import { PriceIndexType } from '@eastcoal/shared/enums/PriceIndexType'

import { FloorCard } from '../../../../components/FloorCard'
import { PriceIndexChart } from '../../../../components/PriceIndexChart'

export const PriceIndexChartCard = () => {
  return (
    <FloorCard title='价格指数'>
      <PriceIndexChart
        height={218}
        priceIndexType={PriceIndexType.PRICE_INDEX}
        width={358}
        styles={{
          kindSelect: {
            width: '90px'
          }
        }}
      />
    </FloorCard>
  )
}
